import React from 'react';

const NavigatorPage = () => (
  <div style={{ textAlign: 'center' }}>
    <img src="/assets/img/plan.jpg" alt="Plan" style={{ padding: '1vw', width: '100%' }} />
  </div>
);

export default NavigatorPage;
